import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
// TODO: Update based on requirements on it should parse and share data
import { makeStyles } from '@material-ui/core';
import { amber, blue, deepPurple, green, orange, red } from '@material-ui/core/colors';
import clsx from 'clsx';
const useStyles = makeStyles((theme) => ({
    circle: {
        backgroundColor: theme.palette.common.black,
        borderRadius: 12,
        display: 'inline-block',
        marginRight: theme.spacing(0.5),
        height: 12,
        width: 12,
        '&.open': {
            backgroundColor: green[600],
        },
        '&.searching': {
            backgroundColor: blue[600],
        },
        '&.action-required': {
            backgroundColor: red[600],
        },
        '&.examining': {
            backgroundColor: orange[600],
        },
        '&.quality-review': {
            backgroundColor: green[600],
        },
        '&.canceled, &.cancelled': {
            backgroundColor: deepPurple[600],
        },
        '&.on-hold': {
            backgroundColor: amber[600],
        },
        '&.closed': {
            backgroundColor: theme.palette.secondary.main,
        },
    },
}));
export function CellStatus({ status, colorsByStatus }) {
    if (!status) {
        return null;
    }
    const classes = useStyles();
    const customColor = colorsByStatus && colorsByStatus[status];
    if (customColor) {
        return (_jsxs(_Fragment, { children: [_jsx("span", { className: classes.circle, style: {
                        backgroundColor: customColor,
                    } }), status] }));
    }
    const statusClassName = status.split(' ').join('-').toLowerCase();
    return (_jsxs(_Fragment, { children: [_jsx("span", { className: clsx(classes.circle, statusClassName) }), status] }));
}
